export const labels = {
	title: {
		label: "Label.MobileCreator.Overwrite.Title",
		default: "Project exists",
	},
	overwrite: {
		label: "Label.MobileCreator.Overwrite.Yes",
		default: "Yes, overwrite",
	},
	cancel: {
		label: "Label.MobileCreator.Overwrite.Cancel",
		default: "No, don't overwrite",
	},
	messageHtml: {
		label: "Label.MobileCreator.Overwrite.Message",
		default: "Are you sure you want to overwrite project <strong>{0}</strong>?",
	},
};
